<template>
  <IndexHeader />
  <MineTop />
  <MineBody :menu="this.selectedMenu" />
  <HomePageFooter />
</template>

<script>
// 首页顶部导航栏
import IndexHeader from "../components/IndexHeader/TopBar";
// 个人中心头部
import MineTop from "../components/UserCenter/MineTop";
// 个人中心主体
import MineBody from "../components/UserCenter/MineBody";
// 首页底部Footer
import HomePageFooter from "../components/HomePageFooter/Footer";

import { getUserInfo } from "../server/user_center_info";

export default {
  name: "UserCenterPage",
  mounted() {
    this.fetchUserInfo();
  },
  components: {
    IndexHeader,
    MineTop,
    MineBody,
    HomePageFooter,
  },
  computed: {
    selectedMenu: {
      get() {
        return this.$route.query.m;
      },
    },
  },
  methods: {
    async fetchUserInfo() {
      let info = await getUserInfo();
      if (info != false) {
        this.$store.commit('updateUserCenterInfo', info);
      }
    }
  },
};
</script>